export default __webpack_public_path__ + "static/media/CustomIntegration.03808237.png";